import { motion } from 'framer-motion';

const GOALS = [
  {
    id: 'habits',
    title: 'Build Better Habits',
    description: 'Create lasting positive routines',
    emoji: '🌱'
  },
  {
    id: 'productivity',
    title: 'Boost Productivity',
    description: 'Get more done with less stress',
    emoji: '⚡️'
  },
  {
    id: 'balance',
    title: 'Find Balance',
    description: 'Harmonize work and personal life',
    emoji: '⚖️'
  },
  {
    id: 'growth',
    title: 'Personal Growth',
    description: 'Learn and develop new skills',
    emoji: '🎯'
  }
];

const GoalsStep = ({ formData, onInputChange, onNext, onBack, isValid }) => {
  const handleGoalSelect = (goalId) => {
    const goal = GOALS.find(g => g.id === goalId);
    onInputChange('goals', 'primary', goal.title);
  };

  return (
    <motion.div
      className="onboarding-step goals-step"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <div className="goals-content">
        <div className="goals-header">
          <h2>Choose Your Path</h2>
          <p className="step-description">
            What would you like to achieve?
          </p>
        </div>

        <div className="goals-selection">
          {GOALS.map((goal) => (
            <motion.button
              key={goal.id}
              className={`goal-option ${formData.goals.primary === goal.title ? 'active' : ''}`}
              onClick={() => handleGoalSelect(goal.id)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className="goal-emoji">{goal.emoji}</span>
              <div className="goal-text">
                <h3>{goal.title}</h3>
                <p>{goal.description}</p>
              </div>
            </motion.button>
          ))}
        </div>

        <div className="step-buttons">
          <button 
            className="onboarding-btn secondary"
            onClick={onBack}
          >
            Back
          </button>
          <button 
            className="onboarding-btn"
            onClick={onNext}
            disabled={!isValid}
          >
            Continue
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default GoalsStep; 